import { CircularProgress } from "@mui/material"
import React, { Fragment, useState } from "react"
import ChoiceFilter from "../ChoiceFilter/ChoiceFilter"
import useStyles from "./useStyles"
import { useDispatch, useSelector } from "react-redux"
import {
  changeSearchStatus,
  deleteSearchStatusValue,
  getAllSubscriptionsCommunication,
} from "../../redux/actions/eventanilla"
import { config } from "./utils/config"

export default function FilterInputStatus() {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const { searchValueCUIT, searchClientName, searchStatus } = useSelector(
    (state) => state.eventanilla,
  )
  const dispatch = useDispatch()
  const options = config.map((item) => item.title)

  const changeSelectValues = async (_, newValue) => {
    setLoading(true)
    const value = newValue.pop()

    const state = config.find((state) => state.title === value)
    state
      ? dispatch(changeSearchStatus(state.code))
      : dispatch(deleteSearchStatusValue())

    await dispatch(
      getAllSubscriptionsCommunication(
        searchValueCUIT,
        searchClientName,
        state?.code ?? null,
      ),
    )
    setLoading(false)
  }

  return (
    <Fragment>
      {loading && (
        <div className={classes.loading}>
          <CircularProgress className={classes.iconLoading} />
        </div>
      )}

      <div
        className={classes.containerChoiseFilter}
        style={{
          display: loading ? "none" : "block",
        }}
      >
        <ChoiceFilter
          options={options}
          value={
            searchStatus
              ? [config.find((state) => state.code === searchStatus)?.title]
              : []
          }
          onChange={changeSelectValues}
          placeholder={"Buscar por estado"}
          getOptionLabel={(option) => option}
          getOption={(option) => (
            <div className={classes.optionContainer}>
              {config.find((elem) => elem.title === option)?.icon}
              <p className={classes.p}>{option}</p>
            </div>
          )}
          width={350}
        />
      </div>
    </Fragment>
  )
}
